import script from "./VTableH.vue?vue&type=script&lang=ts&setup=true"
export * from "./VTableH.vue?vue&type=script&lang=ts&setup=true"

import "./VTableH.vue?vue&type=style&index=0&id=7193d2db&lang=sass"

const __exports__ = script;

export default __exports__